<template>
  <div>
    <!-- 出版物经营许可证 -->
    <img style="width: 100%" src="https://cdn.mekoom.com/assets-v3/certificate/出版物经营许可.jpg" alt="">
  </div>
</template>
<script>
  export default {};
</script>
<style scoped>

</style>
